import { Link } from 'react-router-dom';
import { Logo } from '../Logo';
import { useConsent } from '../../lib/consent-context';
import { useLegal } from '../../lib/legal-context';

// First-visit cookie banner. Floating bottom-left card on desktop (echoing the
// reference design but moved off the hero CTAs), full-width bottom sheet on
// mobile. Accept / Reject are equal-weight (GDPR: rejecting must be as easy as
// accepting); "Manage preferences" opens the granular Preference Center.
//
// Copy is read from cmsLegal (REQ-008) — never hardcoded — with a baseline
// fallback so the banner still renders if the CMS fetch hasn't resolved.

const FALLBACK_BLURB =
  'We use necessary cookies to make our site work. With your consent, we also use analytics and marketing cookies to understand usage and improve the site. You can change your choice at any time.';

export function CookieBanner() {
  const { needsBanner, acceptAll, rejectAll, openPreferences } = useConsent();
  const legal = useLegal();
  if (!needsBanner) return null;

  const blurb = legal.cookie_banner_blurb ?? FALLBACK_BLURB;

  return (
    <div className="cookie-banner">
      <div
        className="cookie-banner-card"
        role="dialog"
        aria-modal="true"
        aria-labelledby="cookie-banner-title"
        aria-describedby="cookie-banner-desc"
      >
        <div className="cookie-banner-brand">
          <Logo height={28} />
        </div>
        <h2 id="cookie-banner-title" className="cookie-banner-title">Cookies on Omega Trade</h2>
        <p id="cookie-banner-desc" className="cookie-banner-desc">
          {blurb}{' '}
          See our{' '}
          <Link to="/privacy" target="_blank" rel="noopener noreferrer">Privacy Policy</Link>
          {' '}and{' '}
          <Link to="/cookies" target="_blank" rel="noopener noreferrer">Cookie Policy</Link>.
        </p>
        <div className="cookie-banner-actions">
          <button type="button" className="btn accent" onClick={acceptAll}>Accept all</button>
          <button type="button" className="btn ghost" onClick={rejectAll}>Reject all</button>
          <button type="button" className="btn ghost" onClick={openPreferences}>Manage preferences</button>
        </div>
      </div>
    </div>
  );
}
